'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$RecipeCalendarAppPage$() {
}
export { $c_Lmealorama_AppRouter$RecipeCalendarAppPage$ as $c_Lmealorama_AppRouter$RecipeCalendarAppPage$ };
$p = $c_Lmealorama_AppRouter$RecipeCalendarAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$RecipeCalendarAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$RecipeCalendarAppPage$() {
}
export { $h_Lmealorama_AppRouter$RecipeCalendarAppPage$ as $h_Lmealorama_AppRouter$RecipeCalendarAppPage$ };
$h_Lmealorama_AppRouter$RecipeCalendarAppPage$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1437624412);
});
$p.m = (function() {
  return "RecipeCalendarAppPage";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "RecipeCalendarAppPage";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$RecipeCalendarAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$RecipeCalendarAppPage$, "mealorama.AppRouter$RecipeCalendarAppPage$", ({
  Fw: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$RecipeCalendarAppPage$ as $d_Lmealorama_AppRouter$RecipeCalendarAppPage$ };
var $n_Lmealorama_AppRouter$RecipeCalendarAppPage$;
function $m_Lmealorama_AppRouter$RecipeCalendarAppPage$() {
  if ((!$n_Lmealorama_AppRouter$RecipeCalendarAppPage$)) {
    $n_Lmealorama_AppRouter$RecipeCalendarAppPage$ = new $c_Lmealorama_AppRouter$RecipeCalendarAppPage$();
  }
  return $n_Lmealorama_AppRouter$RecipeCalendarAppPage$;
}
export { $m_Lmealorama_AppRouter$RecipeCalendarAppPage$ as $m_Lmealorama_AppRouter$RecipeCalendarAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Recipe-Calendar-App-Page$.js.map
